import { useCallback, useState } from "react";
import ModalPopup2 from "../components/ModalPopup2";

export default function useCardTourAndDateModal() {
  const [modalState, setModalState] = useState({
    isOpen: false,
    content: "",
    resolve: null,
  });

  const cardTourAndDate = useCallback((content) => {
    return new Promise((resolve) => {
      setModalState({
        isOpen: true,
        content,
        resolve,
      });
    });
  }, []);
  const handleClose = () => {
    modalState.resolve(false);
    setModalState({ ...modalState, isOpen: false });
  };
  const forceClose = () => {
    setModalState({ ...modalState, isOpen: false });
  };
  const CardTourAndDateModal = (
    <ModalPopup2
      content={modalState.content}
      isOpen={modalState.isOpen}
      onClose={handleClose}
    />
  );
  return {
    cardTourAndDate,
    CardTourAndDateModal,
    closeCardTourAndDateModal: forceClose,
  };
}
